import { useModulesContext } from '../context/ModulesContext.js';
export function useAvailableModules() {
    return useModulesContext().modules;
}
//# sourceMappingURL=useAvailableModules.js.map